module.exports = __webpack_public_path__ + "static/media/smart mall edit-mobile.777f9d91.webp";